if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      if (this.dataset.url) {
        this.performRecommendations();
      } else {
        this.initSlider();
        this.initVariantSelects();
        this.initQuickAdd();
      }
    }

    performRecommendations() {
      const recommendations = this.querySelector('[data-recommendations]');
      if (!recommendations) return;

      fetch(this.dataset.url)
        .then(r => r.text())
        .then(text => {
          const html = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!html) return;

          this.classList.remove('hidden');
          document.querySelector('.cart-drawer-items__full')
            ?.classList.remove('.cart-drawer-items__full');

          recommendations.innerHTML = html;
          this.initSlider();
          this.initVariantSelects();
          this.initQuickAdd();
        });
    }

    initSlider() {
      const swiperEl = this.querySelector('.swiper');
      const prevBtn = this.querySelector('.rec-nav-prev');
      const nextBtn = this.querySelector('.rec-nav-next');

      this.slider = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        watchOverflow: true,
        ...(prevBtn && nextBtn ? {
          navigation: { prevEl: prevBtn, nextEl: nextBtn }
        } : {}),
        on: {
          init: s => this.updateNav(s, prevBtn, nextBtn),
          slideChange: s => this.updateNav(s, prevBtn, nextBtn),
        }
      });
    }

    updateNav(swiper, prev, next) {
      if (!prev || !next) return;
      prev.disabled = swiper.isBeginning;
      next.disabled = swiper.isEnd;
      const nav = prev.closest('.rec-nav');
      if (nav) nav.style.visibility = swiper.isBeginning && swiper.isEnd ? 'hidden' : 'visible';
    }

    // ─── Variant select dropdown ──────────────────────────────────────────────

    initVariantSelects() {
      this.querySelectorAll('.rec-variant-select').forEach(select => {
        select.addEventListener('change', () => {
          const card = select.closest('.product-recommendations__item');
          const chosen = select.options[select.selectedIndex];
          const addBtn = card.querySelector('.rec-quick-add');

          addBtn.dataset.variantId = chosen.value;
          addBtn.dataset.available = chosen.disabled ? 'false' : 'true';

          this.updatePrice(card, chosen);
        });
      });
    }

    updatePrice(card, option) {
      const priceEl = card.querySelector('[data-rec-price]');
      if (!priceEl) return;

      const price = parseInt(option.dataset.price, 10);
      const comparePrice = parseInt(option.dataset.comparePrice, 10);
      const fmt = v => new Intl.NumberFormat(
        document.documentElement.lang || 'lt',
        { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }
      ).format(v / 100);

      if (comparePrice && comparePrice > price) {
        priceEl.innerHTML = `<del>${fmt(comparePrice)}</del> <ins>${fmt(price)}</ins>`;
      } else {
        priceEl.textContent = fmt(price);
      }
    }

    // ─── Quick add ────────────────────────────────────────────────────────────

    initQuickAdd() {
      this.querySelectorAll('.rec-quick-add').forEach(btn => {
        btn.addEventListener('click', () => this.handleQuickAdd(btn));
      });
    }

    handleQuickAdd(btn) {
      if (btn.dataset.available === 'false' || btn.disabled) return;

      btn.classList.add('is-loading');
      btn.disabled = true;

      const body = JSON.stringify({
        id: btn.dataset.variantId,
        quantity: 1,
        sections: sectionsToRender.map(s => s.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_add_url}`, {
        ...fetchConfig(),
        body,
      })
        .then(r => { if (!r.ok) throw new Error(); return r.json(); })
        .then(response => {
          sectionsToRender.forEach(section => {
            const el = document.querySelector(section.id);
            if (!el) return;
            el.innerHTML = new DOMParser()
              .parseFromString(response.sections[section.section], 'text/html')
              .querySelector(section.selector)?.innerHTML || '';
          });

         updateCartCounters();
          updateFreeShipping();
          updateDiscountBar();

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && !cartDrawer.classList.contains('is-visible')) {
            cartDrawer.open();
          }

          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          setTimeout(() => {
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 2000);
        })
        .catch(() => {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          setTimeout(() => {
            btn.classList.remove('is-error');
            btn.disabled = false;
          }, 2000);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}